"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var selectGuidedSupportOption = function (subdomain, optionId) {
    return (0, service_1.getService)()
        .post("/guided_support_sessions/subdomain/".concat(subdomain, "/select_option"), {
        option_id: optionId,
    }, {
        withCredentials: true,
    })
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = selectGuidedSupportOption;
